export default __webpack_public_path__ + "static/media/user.a5330c83.svg";